import { Download, FileSpreadsheet } from 'lucide-react';
import { Button } from '../ui/Button';
import { useFinancialReport } from '../../hooks/useFinancialReport';

/**
 * FE-32 — «Exportar XLSX» y «Exportar CSV» del reporte FINANCIAL. El XLSX trae
 * cuatro hojas (Resumen, Gastos, Ingresos, Tarifas) con la forma del cuaderno;
 * el CSV es la lista plana de movimientos.
 */
export function ExportFinanceButtons({ desde, hasta, subunitId, compacto = false }: { desde: string; hasta: string; subunitId?: string; compacto?: boolean }) {
  const { exportar, exportando, error } = useFinancialReport();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem', alignItems: compacto ? 'flex-end' : 'flex-start' }}>
      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        <Button size="sm" variant="secondary" leftIcon={<FileSpreadsheet size={14} />} isLoading={exportando === 'XLSX'} disabled={!!exportando} onClick={() => exportar('XLSX', desde, hasta, subunitId)}>
          Exportar XLSX
        </Button>
        <Button size="sm" variant="ghost" leftIcon={<Download size={14} />} isLoading={exportando === 'CSV'} disabled={!!exportando} onClick={() => exportar('CSV', desde, hasta, subunitId)}>
          CSV
        </Button>
      </div>
      {error && <p style={{ margin: 0, fontSize: '12px', color: '#EF4444', fontWeight: 600 }}>{error}</p>}
    </div>
  );
}
